import { ReauthorizationFinanceService } from "@/features/accounts/finance/services/reauthorization-service";
import { ReauthorizationCrecaService } from "@/features/accounts/creca/services/reauthorization-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { UpdatePaymentApiLoginInfoService } from "@/features/accounts/payment/api/services/update-login-info-service";
import { ReauthorizationEcshopService } from "@/features/accounts/ecshop/services/reauthorization-service";
import { MoneyLinkException, MoneyLinkWarning } from "@/shared/utils/custom-exception";
import { ErrorDialogContext } from "@/shared/context/error-context";

export const useInstitutionsReauthorization = () => {
  const {
    selectedAccount,
  } = useAccountGroupsContext();
  const {
    selectedInstitutionService,
    authType,
  } = useInstitutionsContext();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);
  const reauthorizationFinanceService = new ReauthorizationFinanceService();
  const reauthorizationCrecaService = new ReauthorizationCrecaService();
  const updatePaymentApiLoginInfoService = new UpdatePaymentApiLoginInfoService();
  const reauthorizationEcshopService = new ReauthorizationEcshopService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関サイト認可画面要求（再認可）
  const requestInstitutionsReauthorizationSite = async () => {
    loadingCtx.setIsLoading(true);
    if (!selectedAccount) {
      loadingCtx.setIsLoading(false);
      return;
    }

    try {
      let res;
      // 銀行API再認可
      if (authType === "bank") {
        res = await reauthorizationFinanceService.reauthorizeFinance({
          account_group_id: selectedAccount.accountGroupId,
          finance_account_id: selectedAccount.mlinkAccountId,
        });
      }
      // クレカAPI
      else if (authType === "crecaApi") {
        res = await reauthorizationCrecaService.reauthorizeCreca({
          account_group_id: selectedAccount.accountGroupId,
          creca_account_id: selectedAccount.mlinkAccountId,
        });
      }
      // クレカ・電マネAPI版
      else if (authType === "crecaLookApi" || authType === "emoneyLookApi") {
        res = await updatePaymentApiLoginInfoService.updatePaymentApiLoginInfo({
          account_group_id: selectedAccount.accountGroupId,
          payment_account_id: selectedAccount.mlinkAccountId,
          payment_id: selectedAccount.mlinkId,
          ...(selectedInstitutionService?.companyName !== "" && { institution_name: selectedInstitutionService?.companyName }),
        });
      }
      // ECショップ
      else if (authType === "ecshop") {
        res = await reauthorizationEcshopService.reauthorizeEcshop({
          account_group_id: selectedAccount.accountGroupId,
          ecshop_account_id: selectedAccount.mlinkAccountId,
        });
      }
      // 許可しない動き
      else {
        // エラー時はカスタムメッセージを表示
        setError(new MoneyLinkWarning({
          title: "エラー",
          message: "口座の種類が不明なため、再認可を開始できませんでした",
        }));
        loadingCtx.setIsLoading(false);
        return;
      }

      if (res.redirect_url) {
        window.location.href = res.redirect_url;
      }

    } catch (error) {
      console.log("requestInstitutionsReauthorizationSite:", error);
      // APIエラー時はエラーダイアログを表示（モーダルは閉じない）
      if (error instanceof MoneyLinkException) {
        setError(error);
      } else {
        setError(new MoneyLinkWarning({
          title: "エラー",
          message: "再認可処理中にエラーが発生しました",
        }));
      }
    }
    finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    requestInstitutionsReauthorizationSite,
  };
};
